import { useEffect, useState } from "react";
import { fetchAudit, fetchAdminDefinition } from "@/villa142/api";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("en-GB", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");

const ACTION_LABELS = {
  delete_contribution: "Deleted a contribution",
  delete_question_responses: "Cleared a question's responses",
  delete_contributor_responses: "Cleared a contributor's responses",
  delete_full_project_record: "Cleared the full project record",
  publish_questionnaire: "Published questionnaire",
  delete_visual_study: "Removed a visual study",
  delete_voice_note: "Deleted a voice note",
  delete_media: "Deleted an image",
  client_delete_reflection: "Client removed a reflection",
  add_contributor: "Added a contributor",
  archive_contributor: "Archived a contributor",
  delete_contributor: "Deleted a contributor",
};

export default function HistoryView() {
  const [audit, setAudit] = useState([]);
  const [versions, setVersions] = useState([]);

  useEffect(() => {
    fetchAudit().then(setAudit).catch(() => {});
    fetchAdminDefinition().then((d) => setVersions(d.versions || [])).catch(() => {});
  }, []);

  return (
    <div data-testid="v142-history-view">
      <h2 className="v142-review-chtitle">Questionnaire versions</h2>
      <div className="v142-history-list">
        {versions.map((v) => (
          <div className="v142-history-row" key={v.version}>
            <span className="v142-entry-group">v{v.version}</span>
            <span className="v142-entry-meta">{v.status}{v.published_at ? ` · published ${fmt(v.published_at)}` : ` · created ${fmt(v.created_at)}`}</span>
          </div>
        ))}
      </div>

      <h2 className="v142-review-chtitle" style={{ marginTop: "2.5rem" }}>Reset & publish history</h2>
      {audit.length === 0 ? (
        <p className="v142-support">No destructive actions recorded yet.</p>
      ) : (
        <div className="v142-history-list" data-testid="v142-audit-list">
          {audit.map((a) => (
            <div className="v142-history-row" key={a.id}>
              <span className="v142-entry-group">{ACTION_LABELS[a.action] || a.action}</span>
              <span className="v142-entry-meta">{a.scope} · {a.count} record{a.count === 1 ? "" : "s"} · {a.actor === "client" ? "by the clients" : a.actor === "system" ? "automatic update" : "by the studio"} · {fmt(a.at)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
